module.exports = __webpack_public_path__ + "static/media/pbchangeover.bb28801f.jpg";